// src/layouts/UserLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  HeartIcon,
//   UserGroupIcon,
//   PlusIcon,
//   ClockIcon,
  LogOutIcon,
} from "../../components/Icon/Icon";
import BASE_URL from "../../configs/api";
import { useNavigate, useLocation } from "react-router-dom";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const isActive = (path) => location.pathname === path;

  const [userData, setUserData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    gender: "undefined",
    avatar: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    fetch(`${BASE_URL}/api/auth/profile/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUserData({
          email: data.email || "",
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          gender: data.gender || "undefined",
          avatar: data.anh_dai_dien_url || data.anh_dai_dien,
        });
      })
      .catch((err) => {
        console.error("Lỗi lấy thông tin người dùng:", err);
      });
  }, []);
  return (
    <div className="bg-[#0d0f17] min-h-screen px-[20px] py-[80px] lg:px-[40px] lg:py-[100px] xl:py-[100px]">
      <div className="container mx-auto px-1 md:px-2 lg:px-1">
        <div className="flex flex-col xl:flex-row gap-6 lg:gap-[40px]">
          {/* Sidebar */}
          <div className="bg-[#25272f] w-full xl:w-[20%] min-w-0 rounded-[0.5rem] self-start">
            <div className="flex flex-col justify-between items-center p-[10px] lg:p-[40px] lg:items-start ">
              <p className="text-white font-semibold text-[18px] lg:text-[20px] mb-[20px]">
                Quản lý phim
              </p>
              <ul className="flex flex-row justify-center lg:justify-start lg:flex-col gap-3 md:gap-10 lg:gap-0 text-white text-[13px] lg:text-[14px] w-full">
                <li
                  onClick={() => navigate("/admin/addphim")}
                  className={`flex flex-col lg:flex-row items-center gap-2 lg:gap-4 cursor-pointer transition w-auto lg:w-full py-2 lg:py-4 border-b border-transparent lg:border-white/5
    ${isActive("/user/favorites")
                      ? "text-yellow-400 font-semibold"
                      : "hover:text-yellow-400 text-white"
                    }
  `}
                >
                  <HeartIcon className="w-4 h-4 lg:w-3 lg:h-3" />
                  <span className="text-center lg:text-left">Thêm Phim</span>
                </li>
{/* 
                <li
                  onClick={() => navigate("/danh-sach")}
                  className={`flex flex-col lg:flex-row items-center gap-2 lg:gap-4 cursor-pointer transition w-auto lg:w-full py-2 lg:py-4 border-b border-transparent lg:border-white/5
    ${isActive("/danh-sach")
                      ? "text-yellow-400 font-semibold"
                      : "hover:text-yellow-400 text-white"
                    }
  `}
                >
                  <PlusIcon className="w-4 h-4 lg:w-3 lg:h-3" />
                  <span className="text-center lg:text-left">Danh sách</span>
                </li>

                <li
                  onClick={() => navigate("continue-watching/")}
                  className={`flex flex-col lg:flex-row items-center gap-2 lg:gap-4 cursor-pointer transition w-auto lg:w-full py-2 lg:py-4 border-b border-transparent lg:border-white/5
    ${isActive("/continue-watching")
                      ? "text-yellow-400 font-semibold"
                      : "hover:text-yellow-400 text-white"
                    }
  `}
                >
                  <ClockIcon className="w-4 h-4 lg:w-3 lg:h-3" />
                  <span className="text-center lg:text-left">Lịch sử</span>
                </li>

                <li
                  onClick={() => navigate("/user/profile")}
                  className={`flex flex-col lg:flex-row items-center gap-2 lg:gap-4 cursor-pointer transition w-auto lg:w-full py-2 lg:py-4 border-b border-transparent lg:border-white/5
    ${isActive("/user/profile")
                      ? "text-yellow-400 font-semibold"
                      : "hover:text-yellow-400 text-white"
                    }
  `}
                >
                  <UserGroupIcon className="w-4 h-4 lg:w-3 lg:h-3" />
                  <span className="text-center lg:text-left">Tài khoản</span>
                </li> */}
              </ul>
            </div>

            <div className="hidden xl:flex flex-col gap-1 px-[40px] py-[60px] items-start">
              <img
                className="w-[60px] h-[60px] rounded-[50%] border-[2px] border-[#fff] object-cover"
                src={userData.avatar}
                alt="User Avatar"
              />
              <h5 className="text-white font-semibold text-[14px] mt-[20px]">
                {userData.first_name}
              </h5>
              <span className="text-gray-300 text-[13px] break-all">
                {userData.email}
              </span>
              <button className="flex gap-2 mt-[20px] justify-center items-center text-white hover:text-yellow-400 transition">
                <LogOutIcon className="w-4 h-4 font-semibold" />
                <span className="font-bold text-[14px]">Thoát</span>
              </button>
            </div>
          </div>

          {/* Outlet thay cho phần nội dung thay đổi */}
          <div className="w-full xl:w-[80%] px-1 md:p-2 lg:px-4 lg:py-2">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
